import React from "react";
import PropTypes from "prop-types";

import styles from "./EmptyState.module.scss";

const EmptyState = ({ message, className = "" }) => (
  <p className={`${styles.emptyState} ${className}`}>{message}</p>
);

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default EmptyState;
